import { createActions, createReducer } from 'reduxsauce'

import { AuthenticationTypes } from '../authentication/duckAuthentication'

/* Initial State */
const INITIAL_STATE = {
  error: null
}

/**
 * Creating actions and types with reduxsauce.
 */
const { Types, Creators } = createActions({
  saveCompany: ['company', 'onSuccess', 'onError'],
  removeCompany: ['company', 'onSuccess', 'onError'],
  saveClientCompany: ['clientCompany', 'onSuccess', 'onError'],
  removeClientCompany: ['clientCompany', 'onSuccess', 'onError'],
  setDefaultFarm: ['farmId', 'onSuccess', 'onError'],
  companyError: ['error']
})

const saveCompany = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const removeCompany = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const saveClientCompany = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const removeClientCompany = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const setDefaultFarm = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const companyError = (state = INITIAL_STATE, { error }) => ({
  ...state,
  error
})

const logout = () => ({ ...INITIAL_STATE })


/**
 * Creating reducer with Types.
 */
export default createReducer(INITIAL_STATE, {
  [Types.COMPANY_ERROR]: companyError,

  [Types.SAVE_COMPANY]: saveCompany,
  [Types.REMOVE_COMPANY]: removeCompany,

  [Types.SAVE_CLIENT_COMPANY]: saveClientCompany,
  [Types.REMOVE_CLIENT_COMPANY]: removeClientCompany,

  [Types.SET_DEFAULT_FARM]: setDefaultFarm,

  [AuthenticationTypes.LOGOUT]: logout
})

export {
  Types as CompanyTypes,
  Creators as CompanyActions
}
